import { translations } from './translations';

const LOADING_FALLBACKS = {
  ar: 'جاري التحميل...',
  en: 'Loading...',
  de: 'Wird geladen...',
};

/**
 * Resolve the global loading label for the active (or given) language.
 * Safe to use outside React (e.g. early boot before LanguageProvider).
 */
export function getLoadingText(lang) {
  const language =
    lang ||
    (typeof window !== 'undefined' && localStorage.getItem('language')) ||
    'ar';

  return (
    translations[language]?.common?.loading ||
    translations.en?.common?.loading ||
    LOADING_FALLBACKS[language] ||
    LOADING_FALLBACKS.en
  );
}

export default getLoadingText;
